import { render, staticRenderFns } from "./OnboardingChecklist.vue?vue&type=template&id=06060184&scoped=true&"
import script from "./OnboardingChecklist.vue?vue&type=script&lang=js&"
export * from "./OnboardingChecklist.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingChecklist.vue?vue&type=style&index=0&id=06060184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06060184",
  null
  
)

export default component.exports